import {
  CmsSharedKeys,
  SharedKeys,
  DarklySharedKeys,
  RouterSharedKeys,
} from 'epic-fortnite-shared-values';

import {SharedValuesState} from './shared.types';

export const AppSharedKeys: SharedKeys<SharedValuesState> = {
  ...CmsSharedKeys,
  ...DarklySharedKeys,
  ...RouterSharedKeys,
};
